import { Helmet } from "react-helmet-async";
import seoMeta from "../data/seo.json";

const SITE = process.env.REACT_APP_SITE_URL || "https://blackdogsociety.co.nz";

export const Seo = ({ path = "/", title, description, image = "/og-share.jpg", jsonLd, noindex = false }) => {
  const meta = seoMeta[path] || {};
  const t = title || meta.title || "Black Dog Society";
  const d = description || meta.description || "";
  const canonical = `${SITE}${path === "/" ? "/" : path}`;
  const img = image.startsWith("http") ? image : `${SITE}${image}`;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Black Dog Society" />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
};
